import { render, staticRenderFns } from "./EventListIframe.vue?vue&type=template&id=e666aaa0&"
import script from "./EventListIframe.vue?vue&type=script&lang=ts&"
export * from "./EventListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports